// extracted by mini-css-extract-plugin
module.exports = {"giftNavItem":"_2V7dNL"};